var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlockedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.73504 4.57989C4.73504 2.78615 6.18916 1.33203 7.98291 1.33203C9.77665 1.33203 11.2308 2.78615 11.2308 4.57989C11.2308 4.86312 11.0012 5.09272 10.7179 5.09272C10.4347 5.09272 10.2051 4.86312 10.2051 4.57989C10.2051 3.3526 9.2102 2.35767 7.98291 2.35767C6.75561 2.35767 5.76068 3.3526 5.76068 4.57989V6.80212H12.0855C13.124 6.80212 13.9658 7.64397 13.9658 8.68246V12.785C13.9658 13.8235 13.124 14.6654 12.0855 14.6654H3.88034C2.84186 14.6654 2 13.8235 2 12.785V8.68246C2 7.64397 2.84186 6.80212 3.88034 6.80212H4.73504V4.57989ZM3.88034 7.82776C3.4083 7.82776 3.02564 8.21042 3.02564 8.68246V12.785C3.02564 13.2571 3.4083 13.6397 3.88034 13.6397H12.0855C12.5575 13.6397 12.9402 13.2571 12.9402 12.785V8.68246C12.9402 8.21042 12.5575 7.82776 12.0855 7.82776H3.88034ZM7.98291 9.53716C8.26613 9.53716 8.49573 9.76676 8.49573 10.05V11.4175C8.49573 11.7007 8.26613 11.9303 7.98291 11.9303C7.69968 11.9303 7.47008 11.7007 7.47008 11.4175V10.05C7.47008 9.76676 7.69968 9.53716 7.98291 9.53716Z",
    fill: "#4B4F5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockedIcon);
export default __webpack_public_path__ + "static/media/unlocked-icon.345eb26496d11849bf41c7ef38ece9e0.svg";
export { ForwardRef as ReactComponent };